import {useContext, useEffect, useState} from 'react'
import {Col, Form, Row, Stack} from 'react-bootstrap'
import {useLocation, useSearchParams} from 'react-router-dom'
import {useUserInfo} from '../../../../routing/store/InfoUserProvider'
import {fetchMenuActionsByRole, fetchSubMenuByUrl} from '../../../../services/menu'
import {useAuth2} from '../../../authv2/Auth2Provider'
import {DataUser} from '../../../documentacion/MiFicha/DataUserInterface'
import {DatePickerBusiness} from '../../../generales_component/DatePickerBusiness'
import {PartnerContext} from '../PartnerContexts'

const DocumentsListHeader = () => {
  const {procesosAdmin, unidadesGrouped} = useUserInfo()
  const buttonsData = [
    {
      iconName: 'verify',
      title: 'Borrador',
      stateName: 'borrador',
      color: '#f39c12', // Orange
    },
    {
      iconName: 'verify',
      title: 'Pendiente',
      stateName: 'pendiente',
      color: '#3c50e7', // Orange
    },
    {
      iconName: 'security-user',
      title: 'Enviado',
      stateName: 'completado',
      color: '#2ecc71', // Green
    },
  ]

  const buttonsDataSigned = [
    {
      iconName: 'verify',
      title: 'Pendiente',
      stateName: 'pendiente',
      color: '#f39c12', // Orange
    },
    {
      iconName: 'security-user',
      title: 'Completado',
      stateName: 'completado',
      color: '#2ecc71', // Green
    },
  ]

  const location = useLocation()
  const {selectedRole, selectedCompanyId} = useAuth2()
  const [permissions, setPermissions] = useState<string[]>([])
  const usuarioJSON = localStorage.getItem('userData')
  const [searchParams] = useSearchParams()

  let usuario: DataUser | null = null

  if (usuarioJSON !== null) {
    usuario = JSON.parse(usuarioJSON)
  }

  useEffect(() => {
    const fetchPermissions = async () => {
      const response = await fetchMenuActionsByRole(selectedRole)
      if (response.success) {
        const currentPath = location.pathname
        console.log('currentpath' + JSON.stringify(currentPath))
        const subMenuResponse = await fetchSubMenuByUrl(currentPath)
        if (subMenuResponse.success) {
          console.log('PERMISOS' + JSON.stringify(subMenuResponse))
          const subMenuId = subMenuResponse.data.id_hijo
          const permissionsForSubMenu =
            response.data.find((item: any) => item.subMenuId === subMenuId)?.acciones || []
          setPermissions(permissionsForSubMenu)
        }
      }
    }

    fetchPermissions()
  }, [selectedRole])

  const {
    idProceso,
    setIdProceso,
    setState,
    setStateSigned,
    setSearchTerm,
    searchTerm,
    setUnidad,
    setDates,
    Dates,
    setCurrentPage,
  } = useContext(PartnerContext)

  const handleSearch = (value: string) => {
    setSearchTerm(value)
    setCurrentPage(1)
  }

  const handleProcessChange = (e: any) => {
    setIdProceso(e.target.value)
    setCurrentPage(1)
  }

  const handleUnitChange = (e: any) => {
    setUnidad(e.target.value)
    setCurrentPage(1)
  }

  const handleStateChange = (e: any) => {
    setState(e.target.value)
    setCurrentPage(1)
  }

  const handleStateSignedChange = (e: any) => {
    setStateSigned(e.target.value)
    setCurrentPage(1)
  }

  const handleDateChange = (value: any) => {
    setDates(value)
    setCurrentPage(1)
  }

  return (
    <>
      <div className='mx-8 mt-8 mb-2'>
        <Row>
          <Col>
            <Stack direction='vertical' gap={3} className='h-100'>
              <span className='fw-bold me-2'>Proceso:</span>
              <Form.Control
                as='select'
                onChange={handleProcessChange}
                className={'form-select form-select-solid}'}
                style={{minWidth: '200px'}}
              >
                <option value=''>Seleccione un proceso</option>
                {procesosAdmin.map((process) => (
                  <option value={process.id} key={process.id}>
                    {process.name}
                  </option>
                ))}
              </Form.Control>
            </Stack>
          </Col>
          <Col>
            <Stack direction='vertical' gap={3} className='h-100'>
              <span className='fw-bold me-2'>Unidad:</span>
              <Form.Control
                as='select'
                onChange={handleUnitChange}
                className={'form-select form-select-solid}'}
                style={{minWidth: '200px'}}
              >
                <option value=''>Seleccione una unidad</option>
                {unidadesGrouped[idProceso]?.map((unit) => (
                  <option value={unit.id} key={unit.id}>
                    {unit.name}
                  </option>
                ))}
              </Form.Control>
            </Stack>
          </Col>
          <Col>
            <Stack direction='vertical' gap={3}>
              <span className='fw-bold'>Buscar</span>
              <Form.Control
                type='text'
                className={'form-control-sm same-height'}
                placeholder='Buscar'
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </Stack>
          </Col>
        </Row>
        <Row className='p-1'>
          <Col>
            <Stack direction='vertical' gap={3} className='h-100'>
              <span className='fw-bold'>Rangos de Fecha de Carga</span>
              <DatePickerBusiness value={Dates} onChange={handleDateChange} />
            </Stack>
          </Col>
          <Col>
            <Stack direction='vertical' gap={3} className='h-100'>
              <span className='fw-bold'>Estado Carga:</span>
              <Form.Control
                as='select'
                style={{minWidth: '220px'}}
                onChange={handleStateChange}
                className={'form-select form-select-solid}'}
              >
                <option value=''>Seleccione Estado</option>
                {buttonsData.map((option) => (
                  <option
                    key={option.iconName}
                    value={option.stateName}
                    style={{color: option.color}}
                  >
                    {option.title}
                  </option>
                ))}
              </Form.Control>
            </Stack>
          </Col>
          <Col>
            <Stack direction='vertical' gap={3} className='h-100'>
              <span className='fw-bold'>Estado Firma:</span>
              <Form.Control
                as='select'
                style={{minWidth: '220px'}}
                onChange={handleStateSignedChange}
                className={'form-select form-select-solid}'}
              >
                <option value=''>Seleccione Estado</option>
                {buttonsDataSigned.map((option) => (
                  <option
                    key={option.iconName}
                    value={option.stateName}
                    style={{color: option.color}}
                  >
                    {option.title}
                  </option>
                ))}
              </Form.Control>
            </Stack>
          </Col>
        </Row>
      </div>
    </>
  )
}

export {DocumentsListHeader}
